/**
 * Generic two-level tabs: primary group tabs ([data-tab-group]) and
 * sub-tabs within a group ([data-tab]). Panels are matched by
 * [data-panel-group] / [data-panel] and toggled with the hidden attribute.
 */
window.WsTabs = class WsTabs extends HTMLElement {
  #abort = null;

  connectedCallback() {
    this.#abort = new AbortController();
    const { signal } = this.#abort;

    for (const tab of this.querySelectorAll('[data-tab-group]')) {
      tab.addEventListener('click', () => this.#selectGroup(tab.dataset.tabGroup), { signal });
    }

    for (const tab of this.querySelectorAll('[data-tab]')) {
      tab.addEventListener('click', () => this.#selectTab(tab.dataset.tab), { signal });
    }

    // Mobile: sub-tabs are a <select> dropdown
    for (const select of this.querySelectorAll('[data-tab-select]')) {
      select.addEventListener('change', () => this.#selectTab(select.value), { signal });
    }
  }

  disconnectedCallback() {
    this.#abort?.abort();
  }

  #selectGroup(group) {
    for (const tab of this.querySelectorAll('[data-tab-group]')) {
      tab.setAttribute('aria-selected', String(tab.dataset.tabGroup === group));
    }
    for (const panel of this.querySelectorAll('[data-panel-group]')) {
      panel.hidden = panel.dataset.panelGroup !== group;
    }
  }

  #selectTab(id) {
    for (const tab of this.querySelectorAll('[data-tab]')) {
      tab.setAttribute('aria-selected', String(tab.dataset.tab === id));
    }
    for (const panel of this.querySelectorAll('[data-panel]')) {
      panel.hidden = panel.dataset.panel !== id;
    }
    for (const select of this.querySelectorAll('[data-tab-select]')) {
      select.value = id;
    }
  }
}

if (!customElements.get('ws-tabs')) customElements.define('ws-tabs', WsTabs);
